import mapFunction from './mapResources';

export default mapFunction('order_material_item_documents', {
    isFetching: false,
    items: []
});